// extracted by css-extract-rspack-plugin
export default {"plain":"plain-LrfX0e","empty":"empty-CvCVqH","markdown":"markdown-fmofiL"};